module.exports = __webpack_public_path__ + "static/img/listen2.638f1ef7.gif";